import React, { useState } from 'react';
import { FormField } from '../../molecules/FormField/FormField';
import { Button } from '../../atoms/Button/Button';
import { Notification } from '../../molecules/Notification/Notification';
import { useForgotPassword } from '../../../features/Login/application/useForgotPassword';

export const ForgotPasswordForm: React.FC = () => {
    const { 
        handleSendPasswordResetEmail, 
        email, 
        setEmail, 
        loading, 
        success, 
        error, 
        clearError 
    } = useForgotPassword();

    const [emailError, setEmailError] = useState(false);

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateEmail(email)) {
            setEmailError(true);
            return;
        }
        await handleSendPasswordResetEmail(email);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        if (emailError) setEmailError(false);
    };

    return (
        <>
            <form className="card w-full max-w-md" onSubmit={handleSubmit}>
                <FormField
                    label="Correo electrónico"
                    id="email"
                    type="email"
                    placeholder="Tu@correo.com"
                    value={email}
                    name="email"
                    error={emailError}
                    onChange={handleChange}
                />

                <Button color="primary" type="submit" disabled={loading}>
                    {loading ? 'Enviando...' : 'Enviar enlace'}
                </Button>
            </form>
            
            {success && (
                <Notification
                    message="Se ha enviado un enlace a tu correo electrónico."
                    type="success"
                    onClose={() => {}} 
                />
            )}

            {error && (
                <Notification
                    message={error}
                    type="error"
                    onClose={clearError}
                />
            )}
        </>
    );
};
